/* unplugin-vue-components disabled */import script from "./breadcrumb.vue?vue&type=script&setup=true&lang=js"
export * from "./breadcrumb.vue?vue&type=script&setup=true&lang=js"

import "./breadcrumb.vue?vue&type=style&index=0&id=91079054&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91079054"]])

export default __exports__